import { render, staticRenderFns } from "./Fatura.vue?vue&type=template&id=6df02598"
import script from "./Fatura.vue?vue&type=script&lang=js"
export * from "./Fatura.vue?vue&type=script&lang=js"
import style0 from "./Fatura.vue?vue&type=style&index=0&id=6df02598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports